import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import ColumnButton from "src/components/Page/GridButtons/ColumnButton";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deleteExtraServiceSaga,
  getExtraServiceDetailsSaga,
  getExtraServiceListSaga,
} from "src/store/extra-service/saga";
import {
  ExtraServiceDetailDto,
  ExtraServiceDto,
} from "src/store/extra-service/type";
import ExtraServiceCreateForm from "./create";
import ExtraServiceEditForm from "./edit";
const ExtraServicePage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState<ExtraServiceDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<ExtraServiceDetailDto>();
  const columns = [
    {
      text: t("ExtraService.GroupName"),
      dataField: "ExtraServiceGroupName",
    },
    {
      text: t("ExtraService.Name"),
      dataField: "Name",
    },
    {
      text: t("ExtraService.Icon"),
      dataField: "Icon",
      formatter: (cellContent: string) => <i className={cellContent}></i>,
    },
    {
      text: t("ExtraService.PeriodType"),
      dataField: "PeriodTypeName",
    },
    {
      text: t("ExtraService.PriceWithTax"),
      dataField: "PriceWithTax",
      formatter: (cellContent: boolean) =>
        cellContent ? (
          <i className="text-success bx  bx-check-square"></i>
        ) : (
          <i className="text-danger mdi mdi-close-box-outline"></i>
        ),
    },
    {
      text: t("ExtraService.Price"),
      dataField: "Price",
    },
    {
      text: t("ExtraService.Tax"),
      dataField: "Vat",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("ExtraService.PageTitle")}
        metaTag={t("ExtraService.MetaTag")}
        gridProps={{
          addTitle: t("ExtraService.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getExtraServiceListSaga,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getExtraServiceDetailsSaga({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          deleteButton: {
            text: (id, data: ExtraServiceDto) =>
              t("ExtraService.DeleteQA", {
                name: data.Name,
              }),
            action: deleteExtraServiceSaga,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <ExtraServiceCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getExtraServiceListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <ExtraServiceEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getExtraServiceListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default ExtraServicePage;
